import { ListItem, ListItemText, Typography, useTheme } from '@mui/material';
import { IoCheckmarkCircleSharp } from 'react-icons/io5';
import { NavLink } from 'react-router-dom';

interface SidebarItemProps {
  to: string;
  icon?: JSX.Element;
  label: React.ReactNode;
  type?: string;
  disabled?: boolean;
  end?: boolean;
  isCompleted?: boolean;
  isHovered?: boolean;
}

export default function SidebarItem({
  to,
  icon,
  label,
  type,
  disabled = false,
  end = false,
  isCompleted = false,
  isHovered = true
}: SidebarItemProps) {
  const theme = useTheme();
  return (
    <>
      {type !== 'mobile' ? (
        <ListItem>
          <NavLink
            to={disabled ? '#' : to}
            end={end}
            style={({ isActive }) => ({
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: isHovered ? '6px 10px' : '10px 8px',
              gap: isHovered ? '18px' : '0px',
              textDecoration: 'none',
              borderRadius: '8px',
              color: disabled ? '#aaa' : isActive ? theme.palette.primary.main : '#242424',
              backgroundColor: disabled ? 'transparent' : isActive ? theme.palette.primary.light : 'transparent',
              fontWeight: isActive ? 'bold' : 'normal',
              width: '100%',
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            })}
          >
            {icon}
            {isHovered && <ListItemText primary={label} sx={{ textWrap: 'nowrap' }} />}
            {isCompleted && !disabled && (
              <IoCheckmarkCircleSharp style={{ fontSize: 20, color: theme.palette.primary.main }} />
            )}
          </NavLink>
          {disabled && (
            <Typography variant='caption' color='textSecondary' sx={{ fontSize: '0.5rem', whiteSpace: 'nowrap' }}>
              Coming soon
            </Typography>
          )}
        </ListItem>
      ) : (
        <ListItem className='mobile-sidebar'>
          <NavLink
            to={disabled ? '#' : to}
            end={end}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              padding: '4px 24px',
              gap: '4px',
              textDecoration: 'none',
              borderRadius: '100px',
              color: disabled ? '#aaa' : isActive ? '#fff' : '#777777',
              backgroundColor: disabled ? '#E0E0E0' : isActive ? theme.palette.primary.main : '#FFF',
              border: !isActive && !disabled ? '1px solid #777' : '',
              pointerEvents: disabled ? 'none' : 'auto',
              cursor: disabled ? 'not-allowed' : 'pointer',
              opacity: disabled ? 0.6 : 1
            })}
          >
            {icon}
            <ListItemText primary={label} sx={{ textWrap: 'nowrap' }} />
          </NavLink>
        </ListItem>
      )}
    </>
  );
}
